"use client";
import { showSideMenuAtom } from "@/hooks/showSideMenuAtom";
import { useAtom } from "jotai";
import { Modal } from "@/utils/bootstrap";
import DetectSwipeClose from "@/app/components/lib/DetectSwipeClose";
import useIsRtl from "@/hooks/useIsRtl";

interface props {
  children: React.ReactNode;
}
const SideMenuContainer: React.FC<props> = ({ children }) => {
  const [show, setShow] = useAtom(showSideMenuAtom);

  const isRtl = useIsRtl();
  return show ? (
    <DetectSwipeClose isRtl={isRtl} onClose={() => setShow(false)}>
      <Modal
        style={{ zIndex: 9999 }}
        show={show}
        onHide={() => setShow(false)}
        className={`modal-as-drawer sidemenu fade drawer ${
          isRtl ? "right-align" : "left-align"
        }`}
      >
        <div className="w-100 sidemenu-body">{children}</div>
      </Modal>
    </DetectSwipeClose>
  ) : null;
};

export default SideMenuContainer;
